const getNumWithPad = (num) => String(num).padStart(2, "0");

export const getFormatedTotalFromTimeElapsedObject = (timeObj) => {
  const diffHours = getNumWithPad(timeObj.hours);

  const diffMinutes = getNumWithPad(timeObj.minutes);

  const diffSeconds = getNumWithPad(timeObj.seconds);

  return `${diffHours}:${diffMinutes}:${diffSeconds}`;
};

const getElapsedBetweenTwoInMs = (start, end) => {
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : new Date();

  return endDate - startDate;
};

export const getTotalElapsedTimeInMs = (pagesData) =>
  pagesData.reduce(
    (prev, current) =>
      prev + getElapsedBetweenTwoInMs(current.start, current.end),
    0
  );
